<div *ngIf="label" class="label default" [class.disabled]="disable">
  {{label}}
</div>

<div #dropdownInputWrapper
     class="input-wrapper animation-focus-default"
     [ngClass]="{
      transparent: transparent,
      readonly: readonly,
       'with-description': showDescription,
       'with-template': hasCustomTemplate
       }"
>
  <input type="text"
         [readonly]="readonly"
         class="app-dropdown"
         [(ngModel)]="currentOptionName"
         [ngClass]="{
          'radio': radioButtons, 
          'invalid': control && control.errors && (!control.pristine || control.touched),
          'highlight-focused-input': highlightFocusedInput
        }"
         (click)="inputClick()"
         [id]="formControlName"
         [tabindex]="tabInd"
         [autofocus]="autofocus"
         [disabled]="disable"
         (focus)="onFocus()"
         (blur)="onBlur()"
         autocomplete="nope"
         [placeholder]="placeholder"
         #dropdownInput
  />

  <div *ngIf="showDescription && !hasCustomTemplate" class="description-container">
    <div class="name">{{currentOptionName}}</div>
    <div class="description">{{currentOptionDescription}}</div>
  </div>

<!--  [src]="transparent ? 'assets/icons/icon-chevron-down-gray.svg' : 'assets/icons/icon-chevron-down.svg'"-->
  <img [hidden]="disable"
       [src]="'assets/icons/icon-chevron-down-gray.svg'"
       alt="icon-chevron-down"
       class="dropdown-chevron-icon"
       (click)="toggleDropdown($event)"
       [ngClass]="{opened: showDropdown}"
  />
  <img [hidden]="!disable"
       [src]="'assets/icons/icon-chevron-down-gray.svg'"
       alt="icon-chevron-down"
       class="dropdown-chevron-icon disabled"
  />
</div>

<div [ngClass]="{radio: radioButtons, 'full-width': fullWidth, 'with-description': showDescription}"
     *ngIf="showDropdown"
     @fadeInOut
     class="dropdown-wrapper"
     [ngClass]="dropDownWrapperClasses"
>
  <!-- two wrappers to align custom scroll -->
  <div *ngIf="!radioButtons" class="dropdown-container">
    <div #dropdownScrollContainer class="scroll-container scroll-list-default styled-main-scroll">
      <div
        *ngFor="let item of filteredOptions"
        class="dropdown-item"
        [class.selected]="isOptionObject ? item.id === value : item === value"
        [class.multi-line]="item?.description && showDescription"
        (click)="chooseOption(item)"
        [tabindex]="1"
        #dropdownItems
      >
        <div class="flex flex-col" class="dropDownValue">
          <p>{{isOptionObject ? item.name : item}}</p><!-- Removed as this was breaking other drop downs like period drop down on trasnaction table {{value}} -->
          <p *ngIf="item?.description && !suppressObjectDescription">{{item.description}}</p>
        </div>
      </div>
      <div *ngIf="!isLoading && !filteredOptions.length" class="dropdown-item empty">
        Nothing found
      </div>
      <div *ngIf="isLoading" class="dropdown-item empty">
        <img src="assets/icons/spinning-animation-loading.svg" alt="loading"/>
      </div>
    </div>
  </div>
  <div #optionsListContainer *ngIf="radioButtons" class="radio-buttons-container">
    <app-options-list *ngIf="!hasCustomTemplate"
                      [(ngModel)]="value"
                      (optionSelected)="chooseOption($event)"
                      (keydownTab)="afterOptionTabEvent()"
                      [optionsList]="filteredOptions"
                      [bordered]="true"
                      #optionsListComponent
    >
    </app-options-list>
    <ng-container *ngIf="hasCustomTemplate">
      <ng-content></ng-content>
    </ng-container>
    <div *ngIf="!isLoading && !filteredOptions.length" class="dropdown-item empty">
      Nothing found
    </div>
  </div>
</div>

<div *ngIf="(control.touched && control.invalid)" class="error-message">
  <ng-container *ngIf="control.errors?.required">
    This field is required
  </ng-container>
</div>

<div *ngIf="control?.errors?.custom"
  class="error-message">{{control.errors.custom}}
</div>
